@if (entities) {
  <div mat-dialog-content>
    <table class="table-td-border-right table-no-border-bottom">
      <tr>
        <td>
          <mat-label class="with-icon"><mat-icon fontIcon="filter_alt"></mat-icon>Filter by {{ jobSubmissionLabel }} status</mat-label>
        </td>
        <td>
          <mat-select [formControl]="statusControl"
            placeholder="Select a status" [multiple]='true'>
            <mat-select-trigger>
              @if (statusControl.value.length! > 0) {
                {{ statusControl.value?.[0]!.length > 20 ? (statusControl.value?.[0]! | slice:0:20) + '...' : statusControl.value?.[0]! }}
              }
              @if (statusControl.value?.length! > 1) {
                <span>
                  (+{{ (statusControl.value?.length!) - 1 }} more)
                </span>
              }
            </mat-select-trigger>
            @for (status of statuses; track status) {
              <mat-option [value]="status">
                {{ status }}
              </mat-option>
            }
          </mat-select>
        </td>
      </tr>
      <tr>
        @if (statusControl.value.length > 0) {
          <td>
            <mat-label class="with-icon"><i class="bhi-candidate"></i>Choose {{ candidatesLabel }} ({{ MAX_SELECTIONS }} maximum)</mat-label>
          </td>
          <td>
            <mat-select placeholder="Select a record"
              (selectionChange)="emitSelectedEntites()" [(ngModel)]='chosenEntities'
              [multiple]='true'
              [required]='true'>
              <mat-select-trigger>
                @if (chosenEntities?.length! > 0) {
                  {{ chosenEntities[0]!.displayIdentifier!.length > 20 ? (chosenEntities[0]!.displayIdentifier | slice:0:20) + '...' : chosenEntities[0]!.displayIdentifier }}
                }
                @if (chosenEntities.length! > 1) {
                  <span>
                    (+{{ (chosenEntities.length!) - 1 }} more)
                  </span>
                }
              </mat-select-trigger>
              @for (entity of filteredEntities | async; track entity) {
                <mat-option
                  [disabled]="chosenEntities.length >= MAX_SELECTIONS && !chosenEntities.includes(entity)"
                  [value]="entity">
                  {{ entity.displayIdentifier }}
                </mat-option>
              }
            </mat-select>
          </td>
        }
      </tr>
    </table>
  </div>
}
